import { Component, inject, signal } from '@angular/core';
import { CartDataService } from '../../../services/cart-data.service';
import { I18nPluralPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { HolidayTypes } from '../../../../shared/enums/holiday-types.enum';
import { HolidayDataService } from '../../../services/holiday-data.service';

@Component({
  selector: 'cart-nav',
  imports: [I18nPluralPipe, RouterLink],
  templateUrl: './cart-nav.component.html',
})
export class CartNavComponent {
  cartDataService = inject(CartDataService);
  holidayDataService = inject(HolidayDataService);
  HolidayTypes = HolidayTypes;
  articleMap = signal({
    '=1': 'Nuevo',
    other: 'Nuevos',
  });
}
